export default __webpack_public_path__ + "static/5-projects-tree-felling-776e7b90edc8ccca1f83d17e25c1baac.jpg";